module.exports = __webpack_public_path__ + "1fa1bd93eda67148499dbeba8381722b.woff2";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Heavy.woff2
// module id = 654
// module chunks = 0